import React from 'react';
import { Link } from 'react-router-dom';
import TopNavBar from './firstRow';
import SecondRow from './secondRow';
import CombinedNavbar from './CombinedNavbar';
// import logo from "./assets/MBS-Logo-header.png";
// import logo from "./assets/enhancedLogoMBS.png";

import logo from "./assets/mbsCurrentLogo.png";
import "./css/logoRow.css";

function NavigationBar() {
  return (
      <div style={{position: "sticky", top: "0px", zIndex: "1000"}}>
        {/* <div className="logo-overlay-left">
        <Link className="navbar-brand" to="/">
          <img src={logo} alt="Logo" />
        </Link>
      </div> */}
            <TopNavBar />

            {/* <SecondRow /> */}
      </div>    
  );
}
export default NavigationBar;
